import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { ProductRecommendationLookup } from 'shared/types';

export function useGetProductRecommendations(customername: string) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, isFetching } = useQuery<ProductRecommendationLookup[], Error>(
    ['product-recommendations', customername],
    () => quoteService.getProductRecommendations(customername),
    {
      onError: error => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
      retry: false,
    }
  );
  return { data, isLoading, isFetching } as const;
}
